import React, { forwardRef } from 'react'
import { Block, Heading, Paragraph } from 'suomifi-ui-components'
import LocalizedString from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'
import { FormContainer } from 'todistukset-ui/src/vtj/components/order-wizard/CommonFormComponents.sc'
import { StepComponent } from 'todistukset-ui/src/vtj/components/order-wizard/OrderWizardStep.type'
import { useStore } from 'todistukset-ui/src/vtj/stores/store.util'
import {
  CertificateInformationSection,
  CertificatePrice,
  ContactInfoSection,
  DeliveryInfoSection,
} from 'todistukset-ui/src/vtj/components/order-wizard/OrderSummaryStep/OrderSummarySections.react'
import { checkIfMailDeliveryIsEnabled } from 'todistukset-common/src/vtj/form-check.util'
import { formatEuroCentsIntoEurWithCommaFixedDecimalsIfNeeded } from 'payment-common/src/vtj/payment-v2.util'
import {
  getTodistusProductForForm,
  getTotalPriceForFormInEuroCents,
} from 'todistukset-common/src/vtj/price.util'

const OrderSummaryStep: StepComponent = forwardRef(function OrderSummaryStep(
  { titleId, certificateType },
  _ref
) {
  const {
    forms: { [certificateType]: form },
    common: { lang },
    paymentPriceList,
  } = useStore()

  const priceParams = {
    form,
    priceList: paymentPriceList,
  }

  const todistusProduct = getTodistusProductForForm(priceParams)

  const todistusPrice = formatEuroCentsIntoEurWithCommaFixedDecimalsIfNeeded(
    todistusProduct.priceWithVatInEuroCents
  )

  const totalPrice = formatEuroCentsIntoEurWithCommaFixedDecimalsIfNeeded(
    getTotalPriceForFormInEuroCents(priceParams)
  )

  const isMailDelivery = checkIfMailDeliveryIsEnabled(form)

  return (
    <FormContainer>
      <Block variant="section">
        <Heading variant="h2" id={titleId}>
          <LocalizedString stringKey="orderWizardOrderSummaryStepMainTitle" />
        </Heading>
        <Paragraph>
          <LocalizedString
            stringKey={'orderWizardOrderSummaryStepMainDescription'}
          />
        </Paragraph>
      </Block>
      <CertificateInformationSection
        lang={lang}
        todistusForm={form}
        certificateType={certificateType}
      />
      <DeliveryInfoSection todistusForm={form} />
      {isMailDelivery && <ContactInfoSection todistusForm={form} />}

      <CertificatePrice
        todistusPrice={todistusPrice}
        todistusProduct={todistusProduct}
        totalPrice={totalPrice}
        todistusForm={form}
      />
    </FormContainer>
  )
})

export default OrderSummaryStep
